import { useNavigate } from "react-router-dom";
import { useUserPoints } from "@/hooks/useUserPoints";

export default function PointsBadge() {
  const { balance, loading } = useUserPoints();
  const navigate = useNavigate();
  if (loading) return null;
  return (
    <button
      onClick={() => navigate("/merit-shop")}
      className="inline-flex items-center justify-center gap-1 px-2.5 py-1 text-xs font-stat text-[hsl(var(--tertiary))] min-h-[48px] min-w-[48px] cursor-pointer hover:opacity-75 transition-opacity"
      title={`${balance} mérite${balance > 1 ? "s" : ""} — Ouvrir la boutique`}
      aria-label="Ouvrir la boutique mérites"
    >
      <span className="text-[11px]">⚡</span>
      {balance}
    </button>
  );
}
